import React from "react";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from './PrivateRoute';
import CreateAccount from "./content/create-account/create-account";
import Login from "./content/login/login";
import MyData from "./my-data/my-data";
import withContext from "./context";
import Dashboard from "./content/dashboard/dashboard";
import Cards from "./content/cards/cards";
import Contacts from "./content/contacts/contacts";
import FindPeople from "./content/find-people/find-people";
import ViewCard from "./content/view-card/view-card";
import EditCard from "./content/edit-card/edit-card";
import Notifications from "./content/notifications/notifications";
import Membership from "./content/membership/membership";
import Settings from "./content/settings/settings";
import OrderSummary from "./content/order-summary/order-summary";
import ForgotPassword from "./content/login/forget-password/forgot-password";
import TermsOfUse from "./content/terms-of-use/terms-of-use";
import ContactUs from "./content/contact-us/contact-us";
import NotFound from "./content/404-not-found/not-found";

const LoginWithContext = withContext(Login);
const MyDataContext = withContext(MyData);
const CreateAccountWithContext = withContext(CreateAccount);
const DashboardWithContext = withContext(Dashboard);
const CardsWithContext = withContext(Cards);
const ContactsWithContext = withContext(Contacts);
const FindPeopleWithContext = withContext(FindPeople);
const ViewCardWithContext = withContext(ViewCard);
const EditCardWithContext = withContext(EditCard);
const NotificationsWithContext = withContext(Notifications);
const MembershipWithContext = withContext(Membership);
const SettingsWithContext = withContext(Settings);
const OrderSummaryWithContext = withContext(OrderSummary);
const ForgotPasswordWithContext = withContext(ForgotPassword);
const TermsOfUseWithContext = withContext(TermsOfUse);
const ContactUsWithContext = withContext(ContactUs);

const Routing = () => (
	<Switch>
		<PrivateRoute exact path="/private" component={PrivateRoute} />
		<Route exact path="/" component={LoginWithContext} />
		<Route exact path="/login" component={LoginWithContext} />
		<Route exact path="/email-confirmation/:code/:email" component={LoginWithContext} />
		<Route exact path="/register" component={CreateAccountWithContext} />
		<Route exact path="/forgot-password/:code" component={ForgotPasswordWithContext} />
		<Route exact path="/forgot-password/" component={ForgotPasswordWithContext} />
		<PrivateRoute exact path="/dashboard" component={DashboardWithContext} />
		<PrivateRoute exact path="/my-data" component={MyDataContext} />
		<PrivateRoute exact path="/cards" component={CardsWithContext} />
		<PrivateRoute exact path="/contacts" component={ContactsWithContext} />
		<Route exact path="/find-people/:query" component={FindPeopleWithContext} />
		<Route exact path="/find-people" component={FindPeopleWithContext} />
		<PrivateRoute exact path="/notifications" component={NotificationsWithContext} />
		<Route exact path="/card/:cardId" component={ViewCardWithContext} />
		<PrivateRoute exact path="/edit-card/:cardId/" component={EditCardWithContext} />
		<PrivateRoute exact path="/card/:cardId/:all" component={ViewCardWithContext} />
		{/* <PrivateRoute exact path="/wallet" component={WalletWithContext} /> */}
		<PrivateRoute exact path="/membership" component={MembershipWithContext} />
		<PrivateRoute exact path="/settings" component={SettingsWithContext} />
		<PrivateRoute exact path="/summary" component={OrderSummaryWithContext} />
		<Route exact path="/terms-of-use" component={TermsOfUseWithContext} />
		<Route exact path="/contact-us" component={ContactUsWithContext} />
		<Route component={NotFound} />
	</Switch>
);

export default Routing;